import { FC } from 'react'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface Props {
  onClick: () => void
  className?: string
  iconClassName?: string
  color?: string
}

export const ButtonBack: FC<Props> = ({
  onClick,
  className,
  iconClassName,
  color,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={clsx(s.button, className)}
  >
    <AppIcon
      width={24}
      height={24}
      className={clsx(s.icon, iconClassName)}
      id={AllIcons.ARROW_LEFT}
      color={color}
    />
  </button>
)
